<div class="myre-form__wrapper" #wrapper [class.from-group]="fromGroup">
  @for (element of elements; track trackBy($index, element)) {
    <div
      #formElement
      class="{{ element.elementType }} myre-form__element"
      [attr.dummy]="isDummy(element) || null"
      [class.question]="isQuestion(element)"
      [style.width]="element.width"
      [attr.line]="getLine(element)"
      [attr.label-less]="!hasUpperLabel(element) || null"
    >
      @if (!element.disabled) {
        @if (!isQuestion(element)) {
          @switch (element.elementType) {
            @case ('text') {
              @let text = _asElementText(element);
              <span class="body-class blue word-break">{{
                text.text | translate: text.textBindings
              }}</span>
            }

            @case ('link') {
              @let link = _asElementLink(element);
              <myre-click-or-link
                [link]="link.link"
                [queryParams]="link.queryParams"
                [externalLink]="link.externalLink"
                (onClick)="link.onClick && link.onClick()"
              >
                @if (link.onClick) {
                  <a class="link word-break">
                    {{ link.text | translate: link.textBindings }}
                  </a>
                } @else {
                  <span class="word-break">{{
                    link.text | translate: link.textBindings
                  }}</span>
                }
              </myre-click-or-link>
            }

            @case ('separator') {
              @let separator = _asSeparator(element);
              <myre-separator
                [heading]="separator.text"
                [withVerticalSpace]="false"
              />
            }

            @case ('googlemap') {
              @let googleMap = _asGoogleMap(element);
              <myre-googlemap
                [mapApiKey]="googleMap.apiKey"
                [coordinates]="googleMap.coordinates"
                [height]="googleMap.mapHeight"
                [width]="googleMap.mapWidth"
                (pinClick)="googleMap.pinClick($event)"
                (pinOver)="googleMap.pinOver($event)"
              >
                @if (googleMap.tooltipTemplate) {
                  <ng-template myreGmTooltipTemplate let-coordinate>
                    <ng-container
                      [ngTemplateOutlet]="googleMap.tooltipTemplate"
                      [ngTemplateOutletContext]="{ $implicit: coordinate }"
                    />
                  </ng-template>
                }
              </myre-googlemap>
            }

            @case ('button') {
              @let button = _asElementButton(element);
              <myre-action-button
                (onClick)="button.onClick()"
                [buttonId]="prefix + button.key"
                [adaptText]="true"
                [label]="button.label"
                [iconName]="button.iconName"
                [withDesktopIcon]="button.withDesktopIcon"
                [onlyIcon]="button.onlyIcon"
                [reverse]="button.reverseIcon"
                [disabled]="button.readonly"
                [type]="button.type"
                [color]="button.color"
                [reverse]="button.reverse"
              />
            }

            @case ('template') {
              @let template = _asElementTemplate(element);
              <ng-container
                [ngTemplateOutlet]="template.template"
                [ngTemplateOutletContext]="{
                  $implicit: template,
                  elements: allElements,
                }"
              />
            }

            @case ('doc-viewer') {
              @let docViewer = _asDocViewer(element);
              <myre-doc-viewer
                [src]="docViewer.src"
                [extension]="docViewer.extension"
              />
            }

            @case ('banner') {
              @let banner = _asElementBanner(element);
              @if (!banner.deprecatedVersion) {
                <myre-banner
                  [content]="banner.content"
                  [type]="banner.type"
                  [copyToClipboard]="banner.copyToClipboard"
                  [formatToClipboard]="banner.formatToClipboard"
                />
              } @else {
                <myre-banner
                  [color]="banner.color"
                  [infoElements]="banner.infoElements"
                />
              }
            }

            @case ('component') {
              <var #component></var>
            }
          }
        } @else {
          @let question = _asQuestion(element);
          <myre-question
            [question]="question"
            [firstLine]="isFirstLine(question)"
            [attr.myre-question-id]="prefix + question.key"
            [prefix]="prefix"
            [formGroup]="formGroup"
            [fromGroup]="fromGroup"
          />
        }
      }
    </div>
  }

  @if (submitParams) {
    <div class="myre-form__element submit">
      <myre-action-button
        [submit]="true"
        [label]="submitParams.label"
        [adaptText]="true"
        [disabled]="formGroup && !formGroup.valid"
        [buttonId]="prefix + 'submit'"
        type="primary"
      />
    </div>
  }

  @if (errorMessage) {
    <div class="myre-form__element">
      <div class="body-class error error-message">
        {{ errorMessage | translate }}
      </div>
    </div>
  }
</div>
